/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Weight_HintInputs */

const en_ui_onboarding_weight_hint = /** @type {(inputs: Ui_Onboarding_Weight_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For calories on runs and from heart rate`)
};

const de_ui_onboarding_weight_hint = /** @type {(inputs: Ui_Onboarding_Weight_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Kalorien bei Läufen und aus der Herzfrequenz`)
};

/**
* | output |
* | --- |
* | "For calories on runs and from heart rate" |
*
* @param {Ui_Onboarding_Weight_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_weight_hint = /** @type {((inputs?: Ui_Onboarding_Weight_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Weight_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_weight_hint(inputs)
	return de_ui_onboarding_weight_hint(inputs)
});